import { render, staticRenderFns } from "./SettlementOrderDetail.vue?vue&type=template&id=1a033a32&scoped=true&"
import script from "./SettlementOrderDetail.vue?vue&type=script&lang=js&"
export * from "./SettlementOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a033a32",
  null
  
)

export default component.exports